<template>
  <v-container> 
    <v-layout row wrap>
      <v-flex xs12 offset-xs9>
        
        <v-btn color="info" @click="addNew">Dodaj nową</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"
              :server-items-length="totalResults"              
              :footer-props="{
                        itemsPerPageOptions:[20,50,100,200],                        
              }"  
              :headers="headers">
              <template v-slot:item.id="{item}">
                  <v-layout align-center>                           
                    <v-icon small class="mr-2" v-if="item.id != 1" @click="editRole(item.id)" title="Edytuj">fa-edit</v-icon>
                    <v-icon small v-if="!item.isStatic"  @click="deleteRole(item.id)" itle="Usuń">fa-trash-alt</v-icon>
                  </v-layout>                  
              </template>                                               
        </v-data-table>    
        <AddEditRole v-if="showAddRole" :visible="showAddRole" :id="selectedRoleId" @close="closeAddPopup"/>
      </v-flex>
    </v-layout>           
  </v-container>
</template>

<script>
import {  mapActions } from "vuex";
import { roleService } from "@/services/";
import AddEditRole from "./AddEditRole";
import swal from "sweetalert";
export default {
  name: "RolesAdmin",
  data() {
    return {
      loading: true,
      showAddRole: false,
      selectedRoleId: 0,
      totalResults: 0,
      items: [],
      pagination: {},
      headers: [
        { text: "Nazwa", sortable: true, align: "left", value: "displayName" },
        { text: "Opis", sortable: true, align: "left", value: "description" },
        { text: "Akcje", sortable: false, align: "left", value: "id" }
      ]
    };
  },
  components: { AddEditRole },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    addNew() {
      this.selectedRoleId = 0;
      this.showAddRole = true;
    },
    editRole(id) {
      this.selectedRoleId = id;
      this.showAddRole = true;
    },
    deleteRole(id) {
      swal({
        title: "Czy na pewno?",
        text:
          "Usuniecię tej roli, może powodować iż niektórzy użytkownicy nie będą mogli się zalogować!",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          roleService
            .deleteRole(id)
            .then(resp => {
              if (resp.data == null || !resp.data.success) {
                throw "Error usuwania roli";
              } else {
                this.success("Usunięto");
                this.refreshTable();
              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można usunąć roli");
            });
        }
      });
    },
    refreshTable() {
      this.loading = true;

      this.requestRoles().then(data => {
        (this.items = data.data.result.items),
          (this.totalResults = data.data.result.totalCount);
        this.loading = false;
      });
    },
    closeAddPopup() {
      this.selectedRoleId = 0;
      this.showAddRole = false;
      this.refreshTable();
    },
    requestRoles() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }

      var req = roleService.getAll({
        query: "",
        page: page,
        limit: itemsPerPage,
        sorting: sortValue
      });
      return req.catch(() => {
        this.error("Błąd pobierania ról");
      });
    }
  },
  created() {
    this.updateTitle("Administracja systemem - zarządzanie rolami");
  },
  beforeMount() {},
  watch: {
    pagination: {
      handler() {
        this.requestRoles().then(data => {
          (this.items = data.data.result.items),
            (this.totalResults = data.data.result.totalCount);
          this.loading = false;
        });
      },
      deep: true
    }
  }
};
</script>

<style>
.data-table-poko #roles {
  margin-top: 60px;
}
</style>
